import React, { useEffect, useState } from 'react';
import './App.scss';
import {
    Routes,
    Route,
    Navigate,
    useNavigate,
    useSearchParams,
} from 'react-router-dom';
import routers from 'configs/routers';
import { Backdrop, CircularProgress } from '@mui/material';
import { common } from '@mui/material/colors';
import { RootState } from 'plugins/store';
import { useAppSelector } from 'common/hook';
import { ZIndex } from 'common/constants';
import { Fab } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { getToken } from 'utils/helpers';
import { demoUserId } from 'common/constants';

const App: React.FC = () => {
    const [showFab, setShowFab] = useState(false);
    const navigate = useNavigate();
    const isLoading = useAppSelector(
        (state: RootState) => state.loading.isLoading
    );
    const [searchParams] = useSearchParams();
    const transactionStatus = searchParams.get('vnp_TransactionStatus');
    useEffect(() => {
        const url = localStorage.getItem('urlCallback');
        if (url && transactionStatus === '00') {
            navigate(`${url}?vnp_TransactionStatus=00`);
            localStorage.removeItem('urlCallback');
        }
    }, [navigate, transactionStatus]);
    const userInfo = useAppSelector((state: RootState) => state.user);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const renderRoutes = (routes: any[]) =>
        routes.map((route, index) => {
            const { role, id: userId } = userInfo.attributes;
            if (route.path === '/') {
                return getToken() ? (
                    <Route
                        key={index}
                        path="*"
                        element={
                            <Navigate
                                to={
                                    demoUserId !== userId
                                        ? '/admin/overview'
                                        : '/admin/campaign'
                                }
                                replace
                            />
                        }
                    />
                ) : (
                    <Route
                        key={index}
                        path="*"
                        element={<Navigate to="/login" replace />}
                    />
                );
            }
            if (route.roles && !route.roles.includes(role)) {
                return (
                    <Route
                        key={index}
                        path={route.path}
                        element={<Navigate to="/404" replace />}
                    />
                );
            }
            if (route.children) {
                return (
                    <Route
                        key={index}
                        path={route.path}
                        element={route.element}
                    >
                        {renderRoutes(route.children)}
                    </Route>
                );
            } else {
                return (
                    <Route
                        key={index}
                        path={route.path}
                        element={route.element}
                    />
                );
            }
        });

    const handleScroll = () => {
        if (window.scrollY > 200) {
            setShowFab(true);
        } else {
            setShowFab(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <div className="App">
            <Routes>{renderRoutes(routers())}</Routes>
            {isLoading && (
                <Backdrop
                    sx={{
                        color: common.white,
                        zIndex: ZIndex.Overlay,
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    }}
                    open={isLoading}
                >
                    <CircularProgress size={50} color="inherit" />
                </Backdrop>
            )}
            <Fab
                color="primary"
                onClick={scrollToTop}
                style={{
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                    display: showFab ? 'flex' : 'none',
                }}
            >
                <ArrowUpwardIcon />
            </Fab>
        </div>
    );
};

export default App;
